import { Box, ColorOptions, IconButton, Loader, Spacer, TextInputNewProps } from '@jfs/ui-new'
import { useEffect } from 'react'
import { useLazyApiData, useStores } from '../../../../../data/store'
import { TextInputWithInfo } from '../TextInputWithInfo'

export const IFSCEditText = (props) => {
  const { fetchAllBankDetailsByIFSC } = useStores((store) => ({
    fetchAllBankDetailsByIFSC: store.fetchAllBankDetailsByIFSC,
  }))
  useEffect(() => {
    if (!props.editable && !props.allValues.bankName && !props.allValues.branchName) {
      fetchAllBankDetailsByIFSCApi(props.value)
    }
  }, [props.value, props.editable])
  const [fetchAllBankDetailsByIFSCApi, fetchAllBankDetailsByIFSCHandler] = useLazyApiData(fetchAllBankDetailsByIFSC)
  useEffect(() => {
    if (fetchAllBankDetailsByIFSCHandler?.state === 'fulfilled') {
      const data = fetchAllBankDetailsByIFSCHandler?.data
      if (fetchAllBankDetailsByIFSCHandler?.data) {
        props?.setFieldValue('bankName', data?.bank)
        props?.setFieldValue('branchName', data?.branch)
        props?.reloadStep()
      }
    }
  }, [fetchAllBankDetailsByIFSCHandler?.state])
  return (
    <Box flexDirection="row" align="flex-end">
      <TextInputWithInfo {...props} />
      <Spacer direction="horizontal" size={18} />
      {fetchAllBankDetailsByIFSCHandler.state === 'pending' && (
        <Box justify="flex-end" paddingBottom={4}>
          <Loader type={'small'} />
        </Box>
      )}
      {fetchAllBankDetailsByIFSCHandler.state !== 'pending' && props.editable && (
        <IconButton
          id="SEARCH"
          color="PRIMARY"
          onPress={() => {
            if (props.value?.length > 0) {
              fetchAllBankDetailsByIFSCApi(props.value)
            }
          }}
        />
      )}
    </Box>
  )
}

const styles = {
  textinputStyle: (editable: boolean) =>
    ({
      borderColor: editable ? ('#D1D3E2' as ColorOptions) : undefined,
      labelPaddingBottom: 3,
      borderRadius: 4,
      labelFontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      fontWeight: '500',
      selectionColor: 'BLUE',
      editable,
      paddingHorizontal: editable ? 8 : 0,
      color: 'BLACK_21',
      paddingVertical: 8,
      placeholderTextColor: '#757575' as ColorOptions,
      bgColor: editable ? 'WHITE' : 'TRANSPARENT',
      disabled: !editable,
    } as TextInputNewProps),
}
